module.exports = __webpack_public_path__ + "static/media/sun.2178072a.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/sun.png
// module id = 37
// module chunks = 0